/* eslint-disable import/no-anonymous-default-export */
import {
  updatePassword,
  confirmSignIn,
  setUpTOTP,
  verifyTOTPSetup,
  updateMFAPreference,
} from "aws-amplify/auth";
import { TextTrans } from "utils/constants";
import { JA } from "utils/strings.ja";

export default {
  async handleUpdatePassword({ oldPassword, newPassword }) {
    try {
      await updatePassword({ oldPassword, newPassword });
      return { statusCode: 200 };
    } catch (error) {
      if (error.name === "NotAuthorizedException")
        return { data: JA.password.currentIncorrect };

      const key = Object.keys(TextTrans).find((key) =>
        error.message.includes(key)
      );
      return { data: TextTrans[key] || error.message };
    }
  },

  async confirmSignIn({ confirm }) {
    try {
      const { isSignedIn } = await confirmSignIn({
        challengeResponse: confirm,
      });
      if (isSignedIn) return "Success";
    } catch (error) {
      const key = Object.keys(TextTrans).find((key) =>
        error.message.includes(key)
      );
      return TextTrans[key] || error.message;
    }
  },

  async handleTOTPSetup() {
    try {
      const totpSetupDetails = await setUpTOTP();
      const appName = "NTT";
      const setupUri = totpSetupDetails.getSetupUri(appName);
      return setupUri?.href;
    } catch (error) {
      console.log(error);
    }
  },

  async handleTOTPVerification(totpCode) {
    try {
      await verifyTOTPSetup({ code: totpCode });
      // the API refuses an MFA user until Cognito asks them for a code, so a
      // failure here must not be passed over
      await updateMFAPreference({ totp: "PREFERRED" });
      return "Success";
    } catch (error) {
      return error.message;
    }
  },
};
